import React from 'react'

function ButtonSingleMessage(data) {
  return (
    <div>{data.message.button.text}</div>
  )
}

export default ButtonSingleMessage